<template>
    <div class="root">
        <img
            :class="{ spinner: true, small: small }"
            :src="image"
            alt="Loading"
            aria-label="Loading"
        />
        <div v-if="message" class="message">
            {{ message }}
        </div>
    </div>
</template>

<script>
export default {
    name: "Spinner",
    props: {
        small: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: "",
            required: false
        }
    },
    computed: {
        image() {
            return require("../../assets/images/loading.svg");
        }
    }
};
</script>

<style scoped>
.root {
    outline: none;
}

.spinner {
    width: 4em;
    margin: auto;
    outline: none;
}

.message {
    outline: none;
}

.spinner.small {
    width: 2.5em;
}
</style>
